// Actions
export const CUSTOMER_LEADS__GET_MESSAGES = 'CUSTOMER_LEADS__GET_MESSAGES';
export const CUSTOMER_LEADS__SEND_MESSAGE = 'CUSTOMER_LEADS__SEND_MESSAGE';
export const CUSTOMER_LEADS__RESET = 'CUSTOMER_LEADS__RESET';
export const CUSTOMER_LEADS__HIRE_PRO = 'CUSTOMER_LEADS__HIRE_PRO';
export const CUSTOMER_LEADS__DECLINE_PRO = 'CUSTOMER_LEADS__DECLINE_PRO';
export const CUSTOMER_LEADS__INITIALIZE = 'CUSTOMER_LEADS__INITIALIZE';
export const CUSTOMER_LEADS__UPDATE_HIRED_DETAILS = 'CUSTOMER_LEADS__UPDATE_HIRED_DETAILS';
export const CUSTOMER_LEADS__CLOSE_LEAD = 'CUSTOMER_LEADS__CLOSE_LEAD';
export const CUSTOMER_LEADS__STILL_LOOKING = 'CUSTOMER_LEADS__STILL_LOOKING';
export const CUSTOMER_LEADS__REVIEW_REMIND_ME = 'CUSTOMER_LEADS__REVIEW_REMIND_ME';
export const CUSTOMER_LEADS__SUBMIT_REVIEW = 'CUSTOMER_LEADS__SUBMIT_REVIEW';
// Mutations
export const CUSTOMER_LEADS__MUTATE_APPEND_MESSAGE = 'CUSTOMER_LEADS__MUTATE_APPEND_MESSAGE';
export const CUSTOMER_LEADS__MUTATE_SET_MESSAGES = 'CUSTOMER_LEADS__MUTATE_SET_MESSAGES';
export const CUSTOMER_LEADS__MUTATE_LOADING_STATUS = 'CUSTOMER_LEADS__MUTATE_LOADING_STATUS';
